/**
 * One axis + series pair on an amCharts XY chart, with the library handed in.
 *
 * Split out of `charts.ts` so that a caller which loads amCharts on demand does not have to
 * reach through a module that imports it statically. `@/utils/async_chart_loader` is
 * synchronous in spite of its name, and that single import is what kept the whole library in
 * the entry chunk of any app that touched this helper — adok reached it through a *dead*
 * import in `SummaryTab.vue` alone.
 *
 * `charts.ts` still exists and still has the old signature: it wraps this and passes the
 * statically loaded modules, so traforama's charts are untouched by any of it.
 */
const createAxisAndSeries = (
  am4core: any,
  am4charts: any,
  chart: any,
  field: string,
  dateField: string,
  name: string,
  opposite: boolean,
  bulletType: string,
  dashed?: boolean,
  stacked?: boolean,
  valueAxis?: any
) => {
  if (!valueAxis) {
    valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
    valueAxis.fontSize = 7
    if (chart.yAxes.indexOf(valueAxis) !== 0) {
      valueAxis.syncWithAxis = chart.yAxes.getIndex(0)
    }
  }

  const series = chart.series.push(new am4charts.LineSeries())
  series.dataFields.valueY = field
  series.dataFields.dateX = dateField
  series.strokeWidth = 1
  series.yAxis = valueAxis
  series.name = name
  series.tooltipText = `${name}: {name} - [bold]{valueY}[/]`
  series.tensionX = 0.8
  series.showOnInit = true
  series.legendSettings.labelText = `${name}: [bold]{valueY}[/]`

  if (dashed) {
    series.strokeDasharray = 3
    series.strokeWidth = 2
    series.strokeOpacity = 0.5
    series.strokeDasharray = '3,3'
  }
  if (stacked) {
    series.fillOpacity = 0.6
    series.strokeWidth = 2
    series.stacked = true
  }

  const interfaceColors = new am4core.InterfaceColorSet()
  let bullet
  let triangle
  let rectangle
  if (!stacked) {
    switch (bulletType) {
      case 'triangle':
        bullet = series.bullets.push(new am4charts.Bullet())
        bullet.width = 12
        bullet.height = 12
        bullet.horizontalCenter = 'middle'
        bullet.verticalCenter = 'middle'

        triangle = bullet.createChild(am4core.Triangle)
        triangle.stroke = interfaceColors.getFor('background')
        triangle.strokeWidth = 2
        triangle.direction = 'top'
        triangle.width = 12
        triangle.height = 12
        break
      case 'rectangle':
        bullet = series.bullets.push(new am4charts.Bullet())
        bullet.width = 10
        bullet.height = 10
        bullet.horizontalCenter = 'middle'
        bullet.verticalCenter = 'middle'

        rectangle = bullet.createChild(am4core.Rectangle)
        rectangle.stroke = interfaceColors.getFor('background')
        rectangle.strokeWidth = 2
        rectangle.width = 10
        rectangle.height = 10
        break
      default:
        bullet = series.bullets.push(new am4charts.CircleBullet())
        bullet.circle.strokeWidth = 0.5
        bullet.circle.radius = 2.5

        break
    }
  }

  valueAxis.renderer.line.strokeOpacity = 1
  valueAxis.renderer.line.strokeWidth = 2
  valueAxis.renderer.line.stroke = series.stroke
  valueAxis.renderer.labels.template.fill = series.stroke
  valueAxis.renderer.opposite = opposite
  valueAxis.tooltip.disabled = true
}

export default createAxisAndSeries
